"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _callEach = _interopRequireDefault(require("./utilities/callEach"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LoginManager = /*#__PURE__*/function () {
  function LoginManager(service) {
    var _this = this;

    _classCallCheck(this, LoginManager);

    this.onChangeCallbacks = [];
    this.service = service;
    this.service.onChange(function () {
      (0, _callEach["default"])(_this.onChangeCallbacks, _this);
    });
  } // Event handlers


  _createClass(LoginManager, [{
    key: "onChange",
    value: function onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }
  }, {
    key: "offChange",
    value: function offChange(cb) {
      if (this.onChangeCallbacks.includes(cb)) {
        this.onChangeCallbacks.splice(this.onChangeCallbacks.indexOf(cb), 1);
        return true;
      }

      return false;
    } // Class methods

  }, {
    key: "login",
    value: function login() {
      this.service.login();
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.service.logout();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }() // Class properties

  }, {
    key: "accountOverviewUrl",
    get: function get() {
      return this.service.accountOverviewUrl;
    }
  }, {
    key: "authState",
    get: function get() {
      return this.service.authState;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      return this.service.cartUrl;
    }
  }, {
    key: "itemsInCart",
    get: function get() {
      return this.service.itemsInCart;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      return this.service.logoutUrl;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      return this.service.loginUrl;
    }
  }, {
    key: "userName",
    get: function get() {
      return this.service.userName;
    }
  }, {
    key: "userFirstName",
    get: function get() {
      return this.service.userFirstName;
    }
  }]);

  return LoginManager;
}();

exports["default"] = LoginManager;